import { SxProps, Theme } from "@mui/material";
import AdditionalInfo from "../common/additionalInfo/additionalInfo";

export default function DepositAdditionalInfo({
  depositAmount,
  sx,
}: {
  depositAmount: number;
  sx?: SxProps<Theme>;
}) {
  return (
    <AdditionalInfo
      variant="info"
      text={`The $${depositAmount} deposit you pay today will be deducted from the amount you owe at a future appointment.`}
      sx={{ mt: 3, ...sx }}
    />
  );
}
